import { SelectOption } from '@/shared/types';

import { UserServicePaymentType } from '@/api/types';

export const paymentTypes: Partial<Record<UserServicePaymentType, SelectOption<string>>> = {
  [UserServicePaymentType.ONLINE]: { id: UserServicePaymentType.ONLINE, label: 'Оплатити послугу онлайн' },
  [UserServicePaymentType.OFFLINE]: {
    id: UserServicePaymentType.OFFLINE,
    label: 'Завантажити копію платіжного документа',
  },
};
